import { FormItemProps, Input } from 'antd';
import { observer } from 'mobx-react-lite';
import { FormItem } from 'src/components/Form/FormItem';
import styled from 'styled-components';

type TextFieldProps = FormItemProps & {
    label?: React.ReactNode;
    inputProps?: any;
};

export const TextField = observer(
    ({ inputProps, ...props }: TextFieldProps) => {
        return (
            <FormItem {...props}>
                <StyledInput {...inputProps} />
            </FormItem>
        );
    },
);

const StyledInput = styled(Input)`
    height: 40px;
    padding: 8px 12px;
    border-radius: 6px;
`;
